import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { useI18n } from "@/context/I18n";
import TrackRow from "@/components/music/TrackRow";
import { Loader2, Play, Sparkles } from "lucide-react";

const MOOD_STYLES = {
  chill: "from-teal-500 to-cyan-700", party: "from-fuchsia-500 to-[#FF2A4D]",
  focus: "from-indigo-500 to-blue-800", workout: "from-orange-500 to-red-700",
  romance: "from-rose-400 to-pink-700", sad: "from-slate-500 to-slate-800",
  energy: "from-amber-400 to-orange-700",
};

export default function MoodDetail() {
  const { name } = useParams();
  const [data, setData] = useState(null);
  const { playQueue } = useMusicPlayer();
  const { t } = useI18n();

  useEffect(() => {
    api.get(`/music/moods/${encodeURIComponent(name)}`).then((r) => setData(r.data)).catch(() => setData(false));
  }, [name]);

  if (data === null) return <div className="p-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>;
  if (data === false) return <div className="p-10 text-zinc-400">...</div>;

  return (
    <div data-testid="mood-detail">
      <div className={`p-8 pb-6 bg-gradient-to-b ${MOOD_STYLES[name] || "from-zinc-600"} to-transparent flex items-end gap-6`}>
        <div className={`w-40 h-40 rounded-lg bg-gradient-to-br ${MOOD_STYLES[name] || "from-zinc-600 to-zinc-800"} flex items-center justify-center shadow-2xl shrink-0`}>
          <Sparkles className="w-16 h-16 text-white" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider font-bold">{t("mood")}</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mt-2">{t(`mood_${name}`)}</h1>
          <p className="text-zinc-100 mt-3 text-sm">{data.tracks.length} {t("tracks")}</p>
        </div>
      </div>
      <div className="px-8 py-4">
        <button data-testid="mood-play-all" onClick={() => data.tracks.length && playQueue(data.tracks, 0)} className="w-14 h-14 rounded-full bg-[#FF2A4D] hover:bg-[#E61C3D] hover:scale-105 flex items-center justify-center transition-all shadow-[0_0_20px_rgba(255,69,0,0.4)]">
          <Play className="w-6 h-6 text-white ml-1" fill="white" />
        </button>
      </div>
      <div className="px-5 pb-6">
        {data.tracks.map((tr, i) => <TrackRow key={tr.id} track={tr} index={i} tracks={data.tracks} />)}
      </div>
    </div>
  );
}
